module.exports = __webpack_public_path__ + "img/photo-1.2862fce7.jpg";